export default __webpack_public_path__ + "static/media/churros.9b5544b8.jpg";